<template>
  <div class="address-container">
    <!-- 筛选栏 -->
    <div class="filter-bar">
      <div class="filter-group">
        <div class="filter-item">
          <button class="add-first-btn" @click="showAddDialog">
            <i class="fas fa-plus"></i>
            {{ $t('_bddz._tjdz') }}
          </button>
        </div>
      </div>

      <div class="search-group">
        <!-- <div class="search-box">
          <i class="fas fa-search"></i>
          <input v-model="filters.search" type="text" :placeholder="$t('_bddz._ssdz')" class="search-input" />
          <button v-if="filters.search" class="clear-search" @click="filters.search = ''">
            <i class="fas fa-times"></i>
          </button>
        </div> -->
      </div>
    </div>
    <div class="transaction-section">
      <!-- 地址列表 -->
      <div class="address-list">
        <div class="list-header">
          <div class="header-cell currency" style="width: 10%">{{ $t('_bddz._bz') }}</div>
          <div class="header-cell address" style="width: 60%">{{ $t('_bddz._dz') }}</div>
          <div class="header-cell time" style="width: 20%">{{ $t('_bddz._sysj') }}</div>
          <div class="header-cell actions" style="width: 10%">{{ $t('_bddz._cz') }}</div>
        </div>

        <div v-for="address in filteredAddresses" :key="address.id" class="address-item" :class="{ recent: isRecent(address.create_time) }">
          <div class="table-cell currency" style="width: 10%">
            <div class="currency-info">
              <!-- <div class="currency-icon" :class="getCurrencyClass(address.name)">
                                <i :class="getCurrencyIcon(address.currency)"></i>
                            </div> -->
              <div class="currency-details">
                <div class="currency-name">{{ address.name }}</div>
                <div class="currency-network">{{ address.network }}</div>
              </div>
            </div>
          </div>

          <div class="table-cell address" style="width: 60%">
            <div class="address-display">
              <div class="address-text" :title="address.address">
                {{ formatAddress(address.address) }}
              </div>
              <div class="address-actions">
                <button class="action-btn copy-btn" @click="copyAddress(address.address)">
                  <copy-outlined />
                </button>
                <button class="action-btn qr-btn" @click="showQRCode(address)">
                  <QrcodeOutlined />
                </button>
              </div>
            </div>
          </div>

          <div class="table-cell time" style="width: 20%">
            <div class="time-display">
              <div class="time-date">{{ formatDate(address.create_time) }}</div>
              <div class="time-diff">{{ getTimeDiff(address.create_time) }}</div>
            </div>
          </div>

          <div class="table-cell actions" style="width: 10%">
            <div class="action-buttons">
              <button class="action-btn use-btn" @click="deleteAddress(address)">
                <DeleteOutlined />
              </button>
              <button class="action-btn use-btn" @click="showDetails(address)">
                <EyeOutlined />
              </button>
            </div>
          </div>
        </div>

        <!-- 空状态 -->
        <div v-if="filteredAddresses.length === 0" class="empty-state">
          <div class="empty-icon">
            <i class="fas fa-address-book"></i>
          </div>
          <h3>{{ $t('_bddz._zwjl') }}</h3>
          <!-- <p>当前筛选条件下没有找到地址记录</p> -->
        </div>
      </div>
    </div>

    <!-- 分页 -->
    <div class="jyjl-pagination" v-if="filteredAddresses.length > 0">
      <button class="jyjl-page-btn" :disabled="page === 1" @click="onPage(page - 1)">
        <left-outlined />
      </button>
      <span class="jyjl-page-info">{{ $t('_bddz._dny', { a: page, b: totalPages }) }} </span>
      <button class="jyjl-page-btn" :disabled="page === totalPages" @click="onPage(page + 1)">
        <right-outlined />
      </button>
    </div>

    <!-- 添加地址弹窗 -->
    <div v-if="showAddModal" class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ $t('_tjdz._tjxd') }}</h3>
          <button class="close-btn" @click="closeModals">
            <close-circle-outlined />
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>{{ $t('_tjdz._xzbz') }}</label>
            <select v-model="pIndex" class="form-select" @change="onSelectChange">
              <option :value="i" v-for="(vo, i) in protocol" :key="i" :checked="vo.c_id == newAddress.c_id">{{ vo.name }} {{ vo.name == vo.network ? '' : '(' + vo.network + ')' }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>{{ $t('_tjdz._qbdz') }}</label>
            <input v-model="newAddress.address" type="text" :placeholder="$t('_tjdz._srdz')" class="form-input" />
          </div>
          <!-- <div class="form-group">
            <label>备注（可选）</label>
            <input v-model="newAddress.note" type="text" placeholder="添加备注信息" class="form-input" />
          </div> -->
        </div>
        <div class="modal-footer">
          <button class="cancel-btn" @click="closeModals">{{ $t('_tjdz._qx') }}</button>
          <button class="confirm-btn" @click="addNewAddress">{{ $t('_tjdz._bc') }}</button>
        </div>
      </div>
    </div>

    <!-- 二维码弹窗 -->
    <div v-show="showQRModal" class="modal-overlay">
      <div class="modal-content qr-modal">
        <div class="modal-header">
          <h3>{{ $t('_bddz._dzewm') }}</h3>
          <button class="close-btn" @click="closeModals">
            <CloseCircleOutlined />
          </button>
        </div>
        <div class="modal-body">
          <div class="qr-code">
            <canvas ref="qrCanvas" class="qr-placeholder"></canvas>
            <!-- <div class="qr-placeholder">
                            <i class="fas fa-qrcode"></i>
                            <span>二维码预览</span>
                        </div> -->
          </div>
          <div class="qr-info">
            <div class="qr-currency">{{ selectedAddress?.currency }}</div>
            <div class="qr-address">{{ selectedAddress?.address }}</div>
            <button class="copy-qr-btn" @click="copyAddress(selectedAddress?.address)">
              <i class="fas fa-copy"></i>
              {{ $t('_bddz._fzdz') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 详情弹窗 -->
    <div v-if="showDetailModal" class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ $t('_bddz._dzxq') }}</h3>
          <button class="close-btn" @click="closeModals">
            <CloseCircleOutlined />
          </button>
        </div>
        <div class="modal-body">
          <div class="detail-item">
            <span class="detail-label">{{ $t('_bddz._bz') }}:</span>
            <span class="detail-value">{{ selectedAddress?.name }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">{{ $t('_bddz._wl') }}:</span>
            <span class="detail-value">{{ selectedAddress?.network }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">{{ $t('_bddz._dz') }}:</span>
            <span class="detail-value address-full">{{ selectedAddress?.address }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">{{ $t('_bddz._tjsj') }}:</span>
            <span class="detail-value">{{ formatFullTime(selectedAddress?.create_time) }}</span>
          </div>
          <div class="detail-item" v-if="selectedAddress?.note">
            <span class="detail-label">{{ $t('_bddz._bzwa') }}:</span>
            <span class="detail-value">{{ selectedAddress.note }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CopyOutlined, QrcodeOutlined, CloseCircleOutlined, DeleteOutlined, EyeOutlined, RightOutlined, LeftOutlined } from '@ant-design/icons-vue'
import QRCode from 'qrcode'
export default {
  name: 'AddressManagement',
  components: { CopyOutlined, QrcodeOutlined, DeleteOutlined, EyeOutlined, RightOutlined, LeftOutlined, CloseCircleOutlined },
  data() {
    return {
      activeMenu: null,
      showAddModal: false,
      showQRModal: false,
      showDetailModal: false,
      selectedAddress: null,
      filters: {
        currency: 'all',
        sortBy: 'newest',
        search: ''
      },
      newAddress: {
        id: 0,
        c_id: 0,
        address: '',
        note: ''
      },
      pIndex: 0,
      protocol: [],

      total: 0,
      page: 1,
      pageSize: 10,
      loading: false,
      addresses: []
    }
  },
  created() {
    this.getWalletAddressList()
  },
  computed: {
    filteredAddresses() {
      let filtered = this.addresses.filter((address) => {
        // 币种筛选
        if (this.filters.currency !== 'all') {
          if (address.currency !== this.filters.currency.split('(')[0]) {
            return false
          }
        }

        // 搜索筛选
        if (this.filters.search) {
          const searchLower = this.filters.search.toLowerCase()
          const matchesAddress = address.address.toLowerCase().includes(searchLower)
          const matchesNote = address.note.toLowerCase().includes(searchLower)
          if (!matchesAddress && !matchesNote) return false
        }

        return true
      })

      // 排序
      filtered.sort((a, b) => {
        if (this.filters.sortBy === 'oldest') {
          return new Date(a.create_time) - new Date(b.create_time)
        } else {
          return new Date(b.create_time) - new Date(a.create_time)
        }
      })

      return filtered
    },
    totalPages() {
      return Math.ceil(this.total / this.pageSize)
    }
  },
  methods: {
    onPage(page) {
      this.page = page
      this.getWalletAddressList()
    },
    getWalletAddressList() {
      let that = this
      var hide = this.$message.loading({ content: this.$t('_a._jzz'), key: 'msg' })
      this.$api.userWallet
        .getWalletAddressList({
          page: that.page,
          size: that.pageSize,
          search: ''
        })
        .then((res) => {
          hide()
          that.addresses = res.data.data
          that.total = res.data.total
        })
    },
    getCurrencyClass(currency) {
      return currency.toLowerCase()
    },
    getCurrencyIcon(currency) {
      const icons = {
        USDT: 'fa-dollar-sign',
        BTC: 'fa-btc',
        ETH: 'fa-ethereum'
      }
      return icons[currency] || 'fa-coins'
    },
    formatAddress(address) {
      if (address.length <= 16) return address
      return address.substring(0, 8) + '...' + address.substring(address.length - 8)
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString('zh-CN')
    },
    formatFullTime(date) {
      return new Date(date).toLocaleString('zh-CN')
    },
    getTimeDiff(date) {
      const now = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }))
      const diff = now - new Date(date)
      const days = Math.floor(diff / (1000 * 60 * 60 * 24))
      const hours = Math.floor(diff / (1000 * 60 * 60))
      const minutes = Math.floor(diff / (1000 * 60))

      if (days > 0) return this.$t('_bddz._ntq', { a: days })
      if (hours > 0) return this.$t('_bddz._nxsq', { a: hours })
      if (minutes > 0) return this.$t('_bddz._nfzq', { a: minutes })
      return this.$t('_bddz._ngg')
    },
    isRecent(date) {
      const now = new Date()
      const sevenDaysAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000)
      return new Date(date) > sevenDaysAgo
    },
    copyAddress(address) {
      navigator.clipboard.writeText(address).then(() => {
        this.$message.success(this.$t('_bddz._dzyfz'))
      })
    },
    showAddDialog() {
      let that = this
      let hide = this.$message.loading({ content: this.$t('_a._jzz'), key: 'msg' })
      this.$api.chain.getCurrencyItemList().then((res) => {
        hide()
        that.protocol = res.data
        that.newAddress.c_id = that.protocol[0].c_id
        that.newAddress.address = ''
        that.showAddModal = true
        this.setSelect(0)
      })
    },
    onSelectChange(e) {
      this.setSelect(e.target.value)
    },
    setSelect(i) {
      this.pIndex = i
      let current = this.protocol[i]
      this.newAddress.c_id = current.p_id
      // console.log('当前选择', this.pIndex, current)
    },
    showQRCode(address) {
      console.log(address)
      this.selectedAddress = address
      this.makeQRCode(address.address)
      this.showQRModal = true
    },
    async makeQRCode(address) {
      try {
        // 生成新的二维码
        this.qrCodeInstance = await QRCode.toCanvas(this.$refs.qrCanvas, address, {
          width: 200,
          height: 200,
          margin: 1,
          color: {
            dark: '#000000',
            light: '#FFFFFF'
          }
        })
        console.log('二维码生成成功')
      } catch (error) {
        console.error('二维码生成失败:', error)
      }
    },
    showDetails(address) {
      this.selectedAddress = address
      this.showDetailModal = true
      this.activeMenu = null
    },
    deleteAddress(item) {
      this.$confirm({
        title: this.$t('_bddz._scqr'),
        content: this.$t('_bddz._scqrdz'),
        okText: this.$t('_bddz._qr'),
        cancelText: this.$t('_bddz._qx'),
        onOk: () => {
          this.$api.userWallet
            .delWalletAddress({ id: item.id })
            .then(() => {
              this.$message.success(this.$t('_bddz._scdzcg'))
              this.activeMenu = null
              this.getWalletAddressList()
            })
            .catch(() => {})
        }
      })
    },
    addNewAddress() {
      // console.log('this.newAddress', this.newAddress)
      if (!this.newAddress.address) {
        this.$message.error(this.$t('_tjdz._srdz'))
        return
      }

      let that = this
      this.$message.loading({ content: this.$t('_a._bcz'), key: 'msg' })
      this.$api.userWallet
        .saveAddress(this.newAddress)
        .then((res) => {
          if (res.code == 1) {
            that.$message.warning({ content: res.msg, key: 'msg' })
            return
          }
          that.$message.success({ content: res.msg, key: 'msg' })
          that.getWalletAddressList()
          that.closeModals()
        })
        .catch(() => {})
    },
    closeModals() {
      this.showAddModal = false
      this.showQRModal = false
      this.showDetailModal = false
      this.activeMenu = null
    }
  },
  mounted() {
    // 点击外部关闭下拉菜单
    document.addEventListener('click', () => {
      this.activeMenu = null
    })
  }
}
</script>

<style scoped>
@import url('../../static/css_address/1.css');
</style>
<style scoped>
.form-select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #0b0d0f !important;
  border-radius: 8px;
  font-size: 14px;
  background: #000 !important;
  color: #fff;
}
</style>
